// extracted by mini-css-extract-plugin
export default {"closeContainer":"ModalButton_closeContainer__yG-UF","leftright":"ModalButton_leftright__yJEhr","rightleft":"ModalButton_rightleft__1ZunK","close":"ModalButton_close__kXQ5W"};